import React from 'react';
import PropTypes from 'prop-types';
import { HelpWrapper, StudentListWrapper } from './styled';

const NeedHelp = (props) => {
  const { helpSeekingStudents, i18n } = props;
  const studentText = helpSeekingStudents.length > 1 ?
    i18n.t`students need help` : i18n.t`student need help`;

  return (<div><HelpWrapper><div className="heading">
    {`${helpSeekingStudents.length} ${studentText}`}</div>
  </HelpWrapper><StudentListWrapper><ul>{helpSeekingStudents.map(s =>
    (<li key={s.id} className="list">{`${s.lastName} ${s.firstName}`}</li>))}</ul>
  </StudentListWrapper></div>);
};

NeedHelp.propTypes = {
  helpSeekingStudents: PropTypes.array,
  i18n: PropTypes.object
};

NeedHelp.defaultProps = {
  helpSeekingStudents: []
};

export default NeedHelp;
